import { BlockingActionOverlay, Text } from "@assetwatch/ui";
import type { TFunction } from "i18next";
import type { JobView } from "../motion-amplification/types";
import {
  actionLabel,
  getJobProgress,
  statusLabel,
} from "./motionAmplificationJobState";

export function JobMedia({ view, t }: { view: JobView; t: TFunction }) {
  const { job, uploadState } = view;
  if (job.processedVideoUrl && job.status === "Completed") {
    return (
      <video
        key={job.processedVideoUrl}
        controls
        preload="metadata"
        className="aspect-video w-full"
        src={job.processedVideoUrl}
      >
        <track kind="captions" />
      </video>
    );
  }

  const isUploading = uploadState === "uploading";
  const isProcessing = job.status === "Processing";
  const isStarting = uploadState === "starting";

  return (
    <BlockingActionOverlay
      label={actionLabel(
        isUploading
          ? t("motionAmplification.uploadingVideo")
          : t("motionAmplification.processing"),
        isStarting ? undefined : getJobProgress(view),
      )}
      open={isUploading || isProcessing || isStarting}
    >
      <div className="flex aspect-video items-center justify-center bg-surface-container">
        {!isUploading && !isProcessing && !isStarting && (
          <Text>{statusLabel(job, t, uploadState)}</Text>
        )}
      </div>
    </BlockingActionOverlay>
  );
}
